import AiTextCreatorEntryPoint from './aiTextCreatorEntryPoint';

export default AiTextCreatorEntryPoint;
